import events from '../events/events';

const Modal = {};

/**
 * Modal plugin
 *
 * @param Vue
 * @param options
 */
Modal.install = function(Vue, options)
{
    let methods =
    {
        /**
         * Show modal and set content
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        show(headline, content, callback, blank, wide)
        {
            this.headline = '';
            this.content = '';
            this.callback = '';

            if (arguments.length == 2 && typeof arguments[1] == 'function')
            {
                this.content = headline;
                this.callback = content;
            }
            else if (arguments.length == 1)
            {
                this.content = headline;
            }
            else
            {
                this.headline = headline;
                this.content = content;
                this.callback = callback;
            }

            // push modal on event bus
            events.$emit('modal.open', this.headline, this.content, this.callback, blank, wide);
        },

        close()
        {
            events.$emit('modal.close');
        },
    };

    // register global methods
    Vue.modal = methods;

    // register instance methods
    Vue.prototype.$modal = methods;
};

export default Modal;



// WEBPACK FOOTER //
// ./src/js/plugins/modal.js